import { AllAPIResponses, CarbonError } from './../../../index';
import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';

type Payload = {
  aliasNodeId: number;
  sourceNodeId: number;
};

const del = async (
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<{}>> => {
  const resp = await req.del(
    '/api/aliaschannels/bulk',
    JSON.stringify(payload),
    headers
  );

  try {
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: {},
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};
export default del;
